var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.supplierClass,
      attrs: { id: _vm.supplier.id },
      on: {
        mouseenter: function ($event) {
          return _vm.mouseEnter(_vm.supplier.id)
        },
        mouseleave: _vm.mouseLeave,
      },
    },
    [
      _c("supplier-checkbox", {
        attrs: { state: _vm.supplier.bidState },
        on: {
          click: function ($event) {
            return _vm.handleSupplierCheckboxClicked(_vm.supplier)
          },
        },
      }),
      _c(
        "div",
        {
          class: _vm.$style.details,
          on: {
            click: function ($event) {
              return _vm.panMapTo(_vm.supplier.location.coordinates)
            },
          },
        },
        [
          _c("div", { class: _vm.$style.detailsNameLine }, [
            _c("div", { class: _vm.nameClass }, [
              _vm.supplier.lastYear
                ? _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.$style.lastYearIcon,
                    },
                    [_vm._v("star")]
                  )
                : _vm._e(),
              _c("span", { staticClass: "vAlignMiddle" }, [
                _vm._v(_vm._s(_vm.supplier.name)),
              ]),
              _vm.supplier.lastYear
                ? _c(
                    "div",
                    {
                      staticClass: "rbTooltip simple",
                      attrs: { tooltip: "placement:top-start" },
                    },
                    [_vm._v(" Was in Last Years Programme ")]
                  )
                : _vm._e(),
            ]),
            _c("span", { staticClass: "vAlignMiddle" }, [
              _vm._v("• " + _vm._s(_vm.supplier.location.fullAddress)),
            ]),
          ]),
          _c("div", { class: _vm.$style.detailsSpecsLine }, [
            _vm.sortedField
              ? _c("span", { class: _vm.$style.badge }, [
                  _vm._v(_vm._s(_vm.sortedField) + " "),
                ])
              : _vm._e(),
            _c("span", [_vm._v(_vm._s(_vm.specification))]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }